import templateUrl from 'emun.prospect/prospect-activity-chart.htm'
import salesrepConfig from 'emun.salesrep/salesrep.config'

class ProspectActivityChartController {
    constructor($window, $rootScope, retailerPrompt, createAutoQuery) { 
        let $ctrl = this;
        $ctrl.statuses = ['New','Active','Converted','Dead'];
		$ctrl.colors = salesrepConfig.chartColors;
        $ctrl.chartLoaded = false;
        this.chartOptions = {
            maintainAspectRatio: false,
            legend: { 
                display: true,
                labels: {
                    boxWidth: 5,
                    fontSize: 10
                }
            },
            elements: {
                rectangle: {
                    borderWidth: 1
                }
            },
            scales: {
                yAxes: [{
                    display: true
                    //ticks: {
                    //    callback: function(value, index, values) {
                    //        return '$' + value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                    //    },
                    //    fontSize: 11
                    //}
                }]
            },
            tooltips: {
                enabled: true
                //callbacks: {
                //    label: function(tooltipItem, data) {
                //        var label = data.datasets[tooltipItem.datasetIndex].label ;
                //        var datasetLabel = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
                //        return label + ": $" + datasetLabel.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                //        //                        return label + ': ' + $filter('currency')(datasetLabel);
                //    }
                //}
            },
        }
        //$ctrl.colors = ['#e80019','#82a96c','#358209','#262626'];
        

        this.last30Query = createAutoQuery({
            url: 'QueryProspects.json?dateRange=Last30&GroupBy=Status',
            autoLoad: true,
            pageSize: 1000,
            onLoaded: function(args) {
                $ctrl.statusNew = [0,0,0];
                $ctrl.statusActive = [0,0,0];
                $ctrl.statusConverted = [0,0,0];
                $ctrl.statusDead = [0,0,0];
                $ctrl.chartData = [];
                $ctrl.chartSeries = ['New','Active','Converted','Dead'];
                args.results.forEach(function(result) {
                    if (result.status == 'New') {
                        $ctrl.statusNew[0] = result.Total;
                    } else if (result.status == 'Active') {
                        $ctrl.statusActive[0] = result.Total;
                    } else if (result.status == 'Converted') {
                        $ctrl.statusConverted[0] = result.Total;
                    } else if (result.status == 'Dead') {
                        $ctrl.statusDead[0] = result.Total;
                    }
                });
                this.qtdQuery = createAutoQuery({
                    url: 'QueryProspects.json?dateRange=Quarter&GroupBy=Status',
                    autoLoad: true,
                    pageSize: 1000,
                    onLoaded: function(args) {
                        args.results.forEach(function(result) {
                            if (result.status == 'New') {
                                $ctrl.statusNew[1] = result.Total;
                            } else if (result.status == 'Active') {
                                $ctrl.statusActive[1] = result.Total;
                            } else if (result.status == 'Converted') {
                                $ctrl.statusConverted[1] = result.Total;
                            } else if (result.status == 'Dead') {
                                $ctrl.statusDead[1] = result.Total;
                            }
                        });
                        this.ytdQuery = createAutoQuery({
                            url: 'QueryProspects.json?dateRange=YTD&GroupBy=Status',
                            autoLoad: true,
                            pageSize: 1000,
                            onLoaded: function(args) {
                                args.results.forEach(function(result) {
                                    //console.info("BL*** comparing result.status: " + result.status);
                                    if (result.status == 'New') {
                                        $ctrl.statusNew[2] = result.Total;
                                    } else if (result.status == 'Active') {
                                        //console.info("BL*** active value = " + result.Total);
                                        $ctrl.statusActive[2] = result.Total;
                                    } else if (result.status == 'Converted') {
                                        //console.info("BL*** converted value = " + result.Total);
                                        $ctrl.statusConverted[2] = result.Total;
                                    } else if (result.status == 'Dead') {
                                        //console.info("BL*** dead value = " + result.Total);
                                        $ctrl.statusDead[2] = result.Total;
                                    }
                                });

                                $ctrl.chartLabels = ["Last 30 Days", "Quarter to Date", "Year to Date"];
                                $ctrl.chartData.push($ctrl.statusNew, $ctrl.statusActive, $ctrl.statusConverted, $ctrl.statusDead);
                                $ctrl.chartLoaded = true;
                            }
                        });
                    }
                });
            }
        });
        $rootScope.$on('refreshProspects', () => $ctrl.last30Query.load(true));
    }
}

let ProspectActivityChart = {
    bindings: {
        rep: '<',
        context: '@'
    },
    //require:{
    //    container: '^salesrepDashboard'
    //},
    controller: ProspectActivityChartController,
    templateUrl($element, $attrs) {
        return $attrs.templateUrl || templateUrl
    }
}

export default ProspectActivityChart